// I will add a utility helper that extracts consistent user contact details from car listing objects.
export const resolveListingUser = (car) => {
const candidateObjects = [];

if (car && typeof car === 'object') {
// Primary known field
if (car.userId && typeof car.userId === 'object') {
candidateObjects.push(car.userId);
}

const potentialObjectFields = [
'user',
'userInfo',
'owner',
'seller',
'createdBy',
'submittedBy',
'listingOwner',
'submittedUser',
'dealer',
'contactPerson',
'sellerInfo',
];

potentialObjectFields.forEach((field) => {
if (car[field] && typeof car[field] === 'object') {
candidateObjects.push(car[field]);
}
});

if (car.submission && typeof car.submission === 'object') {
const submissionObjectFields = [
'contact',
'user',
'submittedBy',
'owner',
];

submissionObjectFields.forEach((field) => {
const value = car.submission[field];
if (value && typeof value === 'object') {
candidateObjects.push(value);
}
});
}

if (car.details && typeof car.details === 'object') {
['seller', 'owner', 'contact'].forEach((field) => {
const value = car.details[field];
if (value && typeof value === 'object') {
candidateObjects.push(value);
}
});
}
}

const stringCandidates = (values) => {
return values.find((value) => typeof value === 'string' && value.trim().length > 0);
};

const collect = (keys) => {
const collected = [];
candidateObjects.forEach((obj) => {
keys.forEach((key) => {
const value = obj?.[key];
if (typeof value === 'string' && value.trim().length > 0) {
collected.push(value.trim());
}
});
});
return collected;
};

const emailCandidates = [
...collect(['email', 'emailAddress', 'contactEmail', 'mail', 'primaryEmail']),
car?.sellerEmail,
car?.contactEmail,
car?.email,
car?.ownerEmail,
car?.dealerEmail,
car?.submission?.contactEmail,
car?.submission?.email,
car?.submission?.contact?.email,
car?.submission?.sellerEmail,
car?.sellerDetails?.email,
];

const nameCandidates = [
...collect(['name', 'fullName', 'displayName', 'username', 'firstName']),
car?.sellerName,
car?.ownerName,
car?.dealerName,
car?.contactName,
car?.name,
];

const avatarCandidates = [
...collect(['avatar', 'profileImage', 'profilePicture', 'profilePhoto', 'photo', 'image', 'picture']),
car?.sellerAvatar,
car?.ownerAvatar,
car?.dealerAvatar,
car?.avatar,
car?.image,
];

const fallbackEmail = stringCandidates(emailCandidates);
const fallbackName = stringCandidates(nameCandidates);
const fallbackAvatar = stringCandidates(avatarCandidates);

return {
email: fallbackEmail || '',
name: fallbackName || '',
avatar: fallbackAvatar || '',
};
};

